export default __webpack_public_path__ + "static/media/meter.2ac9666a.svg";